import { render, staticRenderFns } from "./ProjectsModalDiscard.vue?vue&type=template&id=90cee1b6&"
import script from "./ProjectsModalDiscard.vue?vue&type=script&lang=js&"
export * from "./ProjectsModalDiscard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90cee1b6')) {
      api.createRecord('90cee1b6', component.options)
    } else {
      api.reload('90cee1b6', component.options)
    }
    module.hot.accept("./ProjectsModalDiscard.vue?vue&type=template&id=90cee1b6&", function () {
      api.rerender('90cee1b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/projects/ProjectsModalDiscard.vue"
export default component.exports